import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, Navigate, NavLink, useLocation } from 'react-router-dom';
import './ProfileMenu.scss';
import Icon from '@mdi/react';
import { mdiAccountCircleOutline, mdiAccountTie, mdiLogout, mdiEmailOpen, mdiClipboardTextClock, mdiArrowLeft, mdiClose } from '@mdi/js';
import { LOGOUT } from '../../constants/actionTypes';
import { Helmet } from "react-helmet";
import axios from "axios";
import Modal from 'react-modal';
import ProfileMenuIcon from './images/ProfileMenu.svg';
import ProfileInfoIcon from './images/ProfilInfoIcon.svg';
import ContactUsIcon from './images/Contact us.svg';
import LogoutIcon from './images/Logout.svg';
import DeleteIcon from './images/Delete.svg';
import Footer from '../../components/Footer/Footer';



const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
  onClickLogout: () => dispatch({ type: LOGOUT })
});


const ProfileMenu = (props) => {
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [firstNameData, setFirstNameData] = useState('');
  const [lastNameData, setLastNameData] = useState('');
  const [emailData, setEmailData] = useState('');
  const [profData, setProfData] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cardAddPopup, setCardAddPopup] = React.useState(true);
  const [userId, setUserId] = useState("");
  const [deleteSuccessMessage, setDeleteSuccessMessage] = useState('');
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [deleteCodeError, setDeleteCodeError] = useState(false);



  const profileMenuBackground = require('./images/profile-menu-background.png');

  const customStyles = {
    content: {
      top: '45%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '30px 15px',
      width: '90%'
    },
  };

  useEffect(() => {
    getProfileData();
  }, []);

  const getProfileData = async () => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'user', config);
      //  console.log("DATA", data)
      setFirstNameData(data?.results?.first_name)
      setLastNameData(data?.results?.last_name)
      setEmailData(data?.results?.email)
      setUserId(data?.results?._id);
    } catch (error) {
      setLoading(false)
      //  console.log(error)
    }
  };

  const handleDeleteAccountClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsSecondModalOpen(false);
    setDeleteCodeError(false);
  };

  const DeleteProfile = async () => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
        },
      };
      const { data } = await axios.delete(process.env.REACT_APP_RIDEDOC_API_ROOT + `user/${userId}`, config);
      setDeleteSuccessMessage(data);
      setIsSecondModalOpen(true);
      setIsModalOpen(false);
      //  console.log("User-data", data);
    }
    catch (error) {
      if (error?.response?.status === 406) {
        setDeleteCodeError(true);
        setIsSecondModalOpen(false);
        setIsModalOpen(false);
      }
      // console.log(error);
    }
  }

  return (
    <>
      <div className='profile-menu-info'>
        <div className='main'>

          <Helmet>
            <title>RideDoc | Profile Menu</title>
            <meta name="description" content="Mobile bike mechanics at your door step" />
          </Helmet>
          <div className='header-wrp'>
            <header>
              <div className="header-backic">
                <Link to="/home" className="header-backic-icon">
                  <Icon path={mdiArrowLeft} size={'28px'} color="#222" />
                </Link>
              </div>
              <div className='profile-menu-header-text'>
                <p>Profile</p>
              </div>
            </header>
          </div>

          <div className='main-wrapper'>
            <div className="profile-wrp">
              <section className="profile-user-sec-wrp">
                {/* <div>
              <img src='./images/profile-menu-background.png'
            </div> */}
                <div className="pro-lft-menu">
                  <img src={ProfileMenuIcon} alt='' />
                </div>
                {((firstNameData != null && lastNameData != null)) ?
                  <>
                    <div className='firstName'>{firstNameData}</div>
                    <div className='lastName'>{lastNameData}</div>
                  </>
                  :
                  <>
                    <div className='firstName' style={{ paddingLeft: '1rem' }}>{emailData}</div>
                  </>
                }
                <div className="pro-right">
                  <h3 className='h4'>{props.common.currentUser && props.common.currentUser.firstName} {props.common.currentUser && props.common.currentUser.lastName}</h3>
                  <p>{props.common.currentUser && props.common.currentUser.email}</p>
                </div>
                <div className='dsn-circle'></div>
              </section>
              <section className="profile-user-list-wrp">
                {/* <ul> */}
                <div className='profile-list'>
                  <Link to="/profile-information">
                    {/* <Icon path={mdiAccountTie} size={'24px'} color="#000000" /> */}
                    <img src={ProfileInfoIcon} alt='' className='profile-img' />
                    <p>Profile Information</p>
                  </Link>
                </div>
                <div className='profile-list'>
                  <Link to="/contact-us">
                    {/* <Icon path={mdiEmailOpen} size={'24px'} color="#000000" /> */}
                    <img src={ContactUsIcon} alt='' className='profile-img' />
                    <p>Contact Us</p>
                  </Link>
                </div>
                <div className='profile-list'>
                  <Link onClick={props.onClickLogout}>
                    {/* <Icon path={mdiLogout} size={'24px'} color="#000000" /> */}
                    <img src={LogoutIcon} alt='' className='profile-img' />
                    <p>Logout</p>
                  </Link>
                </div>
                <div className='profile-list'>
                  <Link to="###" onClick={handleDeleteAccountClick}>
                    {/* <Icon path={mdiEmailOpen} size={'24px'} color="#000000" /> */}
                    <img src={DeleteIcon} alt='' className='profile-img' />
                    <p>Delete Account</p>
                  </Link>
                </div>
                <div className='profile-terms'>
                  <div>
                    <Link style={{ color: "#000000", fontSize: "1rem" }} to='/terms-conditions'>Terms of Service</Link>
                    {/* <Icon path={mdiEmailOpen} size={'24px'} color="#000000" /> */}
                    {/* <p style={{color: "#000000", fontSize: "1rem"}}>Terms of Service</p>
                    </Link> */}
                  </div>
                  <div>
                    <Link style={{ color: "#000000", fontSize: "1rem" }} to='/privacy-policy'>Privacy Policy</Link>
                    {/* <Icon path={mdiEmailOpen} size={'24px'} color="#000000" /> */}

                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      // Add other necessary props for styling, accessibility, etc.
      >

        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={handleCloseModal}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content">
              <p className='delete-popup'>Do you want to delete account?</p>
            </div>
          </div>
        </div>
        <div className='modal-prmt-btns delete-modal-btn'>
          <div>
            <button className='btn btn-primary delete-btn1' onClick={handleCloseModal}>No</button>
          </div>
          <div>
            <button className='btn btn-primary delete-btn1' onClick={async () => {
              await DeleteProfile();
              if (deleteCodeError) {
                setDeleteCodeError(true);
              } else {
                setIsSecondModalOpen(true);
              }
            }}>
              Yes
            </button>







          </div>
        </div>

        {/* Modal content goes here */}
      </Modal>

      {deleteSuccessMessage && isSecondModalOpen && (
        <Modal
          isOpen={isSecondModalOpen}
          onRequestClose={handleCloseModal}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          style={customStyles}
          overlayClassName="modal-Overlay"
          contentLabel="Example Modal"
        // Add other necessary props for styling, accessibility, etc.
        >
          <div className='booking-wrp'>
            <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
              <div className="rd-popup-hd">
                <div className="rd-popup-close">
                  <div className='reg-close' onClick={handleCloseModal}>
                    <Icon path={mdiClose} size={'24px'} color="#222" />
                  </div>
                </div>
              </div>
              <div className="rd-popup-content">
                <p className='delete-popup'>Account Deleted Successfully.</p>
              </div>
            </div>
          </div>
          <div className='modal-prmt-btns'>
            <button className='btn btn-primary del-btn' onClick={props.onClickLogout}>ok</button>
          </div>

        </Modal>
      )}

      {deleteCodeError && (
        <Modal
          isOpen={deleteCodeError}
          onRequestClose={handleCloseModal}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          style={customStyles}
          overlayClassName="modal-Overlay"
          contentLabel="Example Modal"
        >
          <div className='booking-wrp'>
            <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
              <div className="rd-popup-hd">
                <div className="rd-popup-close">
                  <div className='reg-close' onClick={handleCloseModal}>
                    <Icon path={mdiClose} size={'24px'} color="#222" />
                  </div>
                </div>
              </div>
              <div className="rd-popup-content">
                <p className='delete-popup'>You can't delete account until pending payments completed.</p>
              </div>
            </div>
          </div>
          <div className='modal-prmt-btns'>
            <button className='btn btn-primary del-btn' onClick={handleCloseModal}>ok</button>
          </div>

        </Modal>
      )}
    </>



  );
  // }
  // else {
  //   return (
  //     <Navigate to="/home" replace={true} />
  //   )
  // }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu);